<template>
	<comp-header class="index-3" />
</template>

<script>
import compHeader from '../components/Toolbars/Default'

export default {
	components: {
		compHeader
	}
}
</script>

<style lang="scss">

</style>


